import "./ProductInstalled.css";
import { useTranslation } from "react-i18next";

const BookIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" {...props}>
    <path
      d="M5 5.5A2.5 2.5 0 0 1 7.5 3H20v16.5H7.5A2.5 2.5 0 0 0 5 22V5.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="currentColor"
      opacity=".1"
    />
    <path d="M5 5.5A2.5 2.5 0 0 1 7.5 3H20M8 7.5h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ChatIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" {...props}>
    <path
      d="M7 18l-4 3V6a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4H7Z"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="currentColor"
      opacity=".08"
    />
    <circle cx="9" cy="11" r="1.2" fill="currentColor" />
    <circle cx="12" cy="11" r="1.2" fill="currentColor" />
    <circle cx="15" cy="11" r="1.2" fill="currentColor" />
  </svg>
);

export default function ProductContact({ catalogUrl, advisorUrl }) {
  const { t } = useTranslation();
  if (!catalogUrl && !advisorUrl) return null;

  return (
    <section className="full-bleed contact-strip contact-strip--premium" aria-label={t("product.contact.aria", "Contact")}>
      <div className="contact-strip__inner--premium">
        <div className="contact-strip__header--premium">
          <h3 className="contact-strip__title--premium">{t("product.contact.title", "¿Ready to transform your space?")}</h3>
          <p className="contact-strip__subtitle--premium">
            {t("product.contact.subtitle", "Discover our full catalog or talk to a specialist")}
          </p>
        </div>

        <div className="contact-strip__actions--premium">
          {catalogUrl && (
            <a className="btn btn--premium btn--catalog" href={catalogUrl} target="_blank" rel="noopener noreferrer">
              <BookIcon />
              {t("product.contact.catalog", "Digital Catalog")}
            </a>
          )}

          {advisorUrl && (
            <a className="btn btn--premium btn--advisor" href={advisorUrl} target="_blank" rel="noopener noreferrer">
              <ChatIcon />
              {t("product.contact.advisor", "Personalized Advice")}
            </a>
          )}
        </div>

        <div className="contact-strip__footer--premium">
          <p className="contact-strip__assurance--premium">{t("product.contact.sla", "⚡ Response in less than 24 hours")}</p>
        </div>
      </div>
    </section>
  );
}
